<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="4">
            <h4>註冊登記列表</h4>
            <h5>當前管理員: {{username}}</h5>
          </b-col>
           <b-col cols="8" class="text-right">
            <b-button v-if="permissionLevel<3.5" variant="success" size="md" @click="createCSV(1)"><i class="fa fa-download mr-2"></i>[2020Q1] Export as CSV</b-button>
            <b-button v-if="permissionLevel<3.5" variant="primary" size="md" @click="createCSV(2)"><i class="fa fa-download mr-2"></i>[2020Q2] Export as CSV</b-button>
            <b-button v-if="permissionLevel<3.5" variant="dark" size="md" @click="createCSV(3)"><i class="fa fa-download mr-2"></i>
            [2020Q3Q4] Export as CSV</b-button>
            <b-button v-if="permissionLevel<3.5" variant="warning" size="md" @click="createCSV(4)"><i class="fa fa-download mr-2"></i>
            [2021P4] Export as CSV</b-button>

          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable :keywordPlaceholder="placeholder" ref="table" :filters="filters" :actions="actions" :columns="updatedColumns" vuexModule="Homepage" searchAction="getRegistrationList" type="product"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">

const copy = require('copy-text-to-clipboard');

const selectionInitial = {
    gender: [],
    brand: [],
    product: [], // With parentKey
    lens: [],
    degree: [], // With parentKey
    region: [],
    district: [], // With parentKey
    store: [], // With parentKey
    productType:[],
}

import { FITSearchableTable, FITFormCard } from '@/components'
import $ from 'jquery'
import Cookies from 'js-cookie'
import * as moment from 'moment';

export default {
  name: 'RegistrationList',
  props: {},
  components: {
    FITSearchableTable,
    FITFormCard,
  },
  created(){
        // List started.
        this.selections = selectionInitial;
        this.getAllSelections('selectionList');
        this.getAllSelections('storeList');
        // console.log(this.selections)
  },
  data(){
  	return{
      placeholder:'Telephone/ PromoteCode/ MerchantID',
      selections:{},
  		filters:[
        {
         key:'phase',
         label:'推廣優惠版本',
         type:'select',
         placeholder:'默認顯示全部',
         options:[
         {value: 4, text:'[2021P4] 2021-01-01 至 今'},
         {value: 3, text:'[2020Q3Q4] 2020-07-01 至 2020-12-31'},
         {value: 2, text:'[2020Q2] 2020-04-01 至 2020-06-30'},
         {value: 1, text:'[2020Q1] 2019-12-26 至 2020-04-14'},
         ],
        }
      ],
  		actions:[
        // {
        //   text: "兌換優惠碼",
        //   key: 'redeem',
        //   class:'text-primary',
        //   callback: (key, row, instance) => {
        //     // Vue.set(this, 'clickedRow', row);
        //     this.redeemRecord(row.ID,row.promoteStatus);
        //   }
        // },
        {
          text: "重新發送優惠短信",
          key: 'resend',
          class:'text-success',
          callback: (key, row, instance) => {
            // Vue.set(this, 'clickedRow', row);
            this.resendRegistrationSMS(row,false);
          }
        },
        {
          text: "複製優惠短信",
          key: 'copySMS',
          class:'text-primary',
          callback: (key, row, instance) => {
            // Vue.set(this, 'clickedRow', row);
            this.resendRegistrationSMS(row,true);
          }
        },
         {
          text: "複製推廣鏈接",
          key: 'copyLink',
          class:'text-primary',
          callback: (key, row, instance) => {
            // Vue.set(this, 'clickedRow', row);
            this.copyPromotionLink(row);
          }
        },
        {
          text: "刪除",
          key: 'delete',
          class: 'text-danger',
          permission:3.5,
          callback: (key, row, instance) => {
            // Vue.set(this, 'clickedRow', row);
            // console.log(row);
            this.deleteRecord(row.ID);
          }
        }
      ],
  		columns:[

       {
          key: 'ID',
          label: '登記ID',
        },

        // {
        //   key: 'name',
        //   label: '姓名',
        // },
        // {
        //   key: 'gender',
        //   label: '性別',
        //   formatter: (row, key, item) => {
        //     return this.getTranslated(key, row);
        //   }
        // },
            {
          key: 'telephone',
          label: '電話號碼',
        },
        //   {
        //   key: 'email',
        //   label: '電郵地址',
        // },
        // {
        //   key: 'brand',
        //   label: '品牌',
        //   formatter: (row, key, item) => {
        //     return this.getTranslated(key, row);
        //   }
        // },
       {
          key: 'product',
          label: '產品',
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },

    {
          key: 'previousProductType',
          label: '現時佩戴之產品',
          formatter: (row, key, item) => {
            return this.getTranslated('productType', row);
          }
        },
         {
          key: 'expectedProductType',
          label: '想佩戴之博士倫產品',
          formatter: (row, key, item) => {
            return this.getTranslated('productType', row);
          }
        },
        {
          key: 'informationFlag',
          label: '接受推廣',
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
       // {
       //    key: 'emailFlag',
       //    label: '通過電郵',
       //    formatter: (row, key, item) => {
       //      return this.getTranslated(key, row);
       //    }
       //  },
       // {
       //    key: 'smsFlag',
       //    label: '通過短信',
       //    formatter: (row, key, item) => {
       //      return this.getTranslated(key, row);
       //    }
       //  },
          {
          key: 'storeID',
          label: '商店ID',
           formatter: (row, key, item) => {
            return item.store;
          }
        },


        {
          key: 'accountID',
          label: '商家編號',
           formatter: (row, key, item) => {
            return this.getTranslated('accountID', item.store);
          }
        },
     
        {
          key: 'region',
          label: '地區',
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        {
          key: 'district',
          label: '地點',
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        {
          key: 'store',
          label: '商店',
          formatter: (row, key, item) => {
             return this.getTranslated(key, row);
          }
        },
        {
          key: 'createTime',
          label:'登記日期',
           formatter: (row, key, item) => {
           return this.getTranslated(key, row);
          }
        },
        {
          key: 'phase',
          label: '登記版本',
          formatter: (row, key, item) => {
            // if(row == 3)
            // return 'Q3Q4'
            // else
            return "P"+row;
          },

        },
        {
          key: 'promoteCode',
          label: '優惠碼',
        },
        {
          key: 'promoteStatus',
          label: '換領狀態',
          // tdClass:[],
          formatter: (row, key, item) => {
            let classStr = 'text-primary';
            if(row == "Y"){
              classStr = 'text-success'; 
            }
            let tag = `<span class="font-weight-bold ${classStr}">${this.getTranslated(key, row)}</span>`
            return tag;
          }
        },
   
        {
          key: 'updateTime',
          label: '換領日期',
          formatter: (row, key, item) => {
           return this.getTranslated(key, row);
          }
        },

      ],
  	}
  },
  computed:{
    permissionLevel() {
      return Cookies.get('permissionLevel');
    },
    username() {
      return Cookies.get('username');
    },
    updatedColumns(){
      let columns = this.columns;
      let ignoreColumns = [
      'informationFlag',
      'emailFlag',
      'smsFlag'
      ];
      let columnIndex= 0;
      if(this.permissionLevel >3.5){
        $.each(columns,(index,value)=>{
          if(value.key == 'informationFlag')
          {
             columnIndex = index ;
          }
        });
        columns.splice(columnIndex,3);    
      }
      return columns;
    }
  },
  methods:{
    copyPromotionLink(record){
      let url = this.getPromotionLink(record)

      copy(url);

      alert("以下推廣鏈接已複製：\n"+url);      
    },

    copyPromotionSMS(record){
       var expiredDate = moment(record.createTime).add(14, 'days').format("YYYY年MM月DD日");
          // var trailStore = this.getStoreDetail(record.store);
          var trailStore ={};
          this.selections.store.forEach((store)=>{
            if(store.ID == record.store){
              trailStore = store;
            }
          });
          let landingURL = this.getPromotionLink(record);
          var veriText = "博士倫: 感謝登記博士倫Biotrue 1-DAY 體驗活動，請憑此短訊於"+expiredDate+"前親臨<"+trailStore.name+"><"+trailStore.district+trailStore.address+">體驗產品。請預先致電或親臨以上地點預約驗眼服務。<"+landingURL+"> 查詢/取消：22133309";
           copy(veriText);
          alert("推廣短信已複製");      
    },

    resendRegistrationSMS(record,copyOnly = false){
      // if(!confirm("確認重新發送註冊登記短信至用戶「"+ record.telephone +"」?")){
      //   return;
      // } 

        this.shortenURL(record, false, copyOnly);
    },
    getPromotionLink(record){
    // Phase 2 Url 
        var url = "https://biotrue.tarvel.co/landing.html?code=" + record.promoteCode + "&type=2";
        // var url = "https://test.ftech.com.hk/biotrue/landing.html?code=" + record.promoteCode + "&type=2";


        // Identify Registration Type, remember to check the +0800 time zone
        var isafter = moment(record.createTime).isAfter('2020-04-01T14:00:00');
        if(!isafter){
        // Phase 1 Url 
        url = "https://biotrue.tarvel.co/landing.html?code=" + record.promoteCode;
        }
        return url;
    },
  shortenURL: function shortenURL(record, retry = false, copyOnly = false){
       
    
        var url  =this.getPromotionLink(record); 

        // var d = new Date();
         // Bit.ly v4
        var bitlyDomain = "bit.ly";
         if(retry){
            bitlyDomain = "url.tarvel.co";
         }
         var params = {
            // "group_guid": "biotrue",
            "domain": bitlyDomain,
            "long_url": url
        };
        var accessToken = '23fa65f793dabb08d2b7fe63200c559eac93a948';
        // var accessToken = 'aba7f34874eb89a71035883a8f55cc7114bef18d';
         $.ajax({
            // url: "https://api-ssl.bitly.com/v4/shorten?_="+d.getTime(),
            url: "https://api-ssl.bitly.com/v4/shorten",
            dataType: "json",
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(params),
            beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", "Bearer " + accessToken);
            },
  
        }).done((data)=> {
            // console.log(data);
              this.registrationSuccess(record, data.link, copyOnly);
                      
        }).fail(function(data) {
            // console.error(data);
            if(retry){
             alert("Shorten URL Failed, please try it later");
            }else{
                app.shortenURL(record, true, copyOnly);            
            }       
             });
},
registrationSuccess: function registrationSuccess(record, landingURL, copyOnly){

    var expiredDate = moment(record.createTime).add(14, 'days').format("YYYY年MM月DD日");
    // var trailStore = this.getStoreDetail(record.store);
    var trailStore ={};
    this.selections.store.forEach((store)=>{
      if(store.ID == record.store){
        trailStore = store;
      }
    });
    var expectedProductTypeFlag = true;

    if(record.expectedProductType == '100' || record.expectedProductType == '000'){
        expectedProductTypeFlag = false;
    }

    var withinDateRange = moment(record.createTime).isSameOrAfter('2020-07-01') && moment(record.createTime).isSameOrBefore('2020-09-30');
        // console.log(record)
    if(trailStore.accountID == '502039' && expectedProductTypeFlag && withinDateRange){
        var veriText = "[特選客戶]博士倫: 感謝登記博士倫Biotrue 1-DAY 體驗活動，你已被選中專享隱形眼鏡驗配服務一次!請憑此短訊於"+expiredDate+"前親臨<"+trailStore.name+"><"+trailStore.district+trailStore.address+"><電話: "+trailStore.phone+">，讓你感受16小時真·保濕。此活動由博士倫贊助並受有關條款及細則約束<https://bit.ly/3hBGpmJ>，詳情請向店員查詢。換領連結:<"+landingURL+"> 查詢/取消：22133309";
    }
    else{
        var veriText = "博士倫: 感謝登記博士倫Biotrue 1-DAY 體驗活動，請憑此短訊於"+expiredDate+"前親臨<"+trailStore.name+"><"+trailStore.district+trailStore.address+"><電話: "+trailStore.phone+">體驗產品。<"+landingURL+"> 查詢/取消：22133309";
    }

    if(copyOnly){
      copy(veriText);
      alert("已複製推廣優惠短信.");
      return;
    }

    let param = {
      telephone: record.telephone,
      content: veriText
    }

      var confirmMsg = '確認重新發送至:\n'+"電話號碼: "+param.telephone+"\n"+
       param.content;
       if(!confirm(confirmMsg)){return}

    this.$store.dispatch('Homepage/sendSMS',param);
    alert("註冊登記SMS已重新發送");
 },

    createCSV(phase){
      this.$store.dispatch('Homepage/BIExportCSV',{type:'registration', phase: phase});
    },
    redeemRecord(ID,status){

      if(status == 'Y'){
        alert("該推廣優惠碼已兌換");
        return;
      }

      if(!confirm("確認兌換該用戶的推廣優惠碼？")){
        return ;
      }

      if(!ID){
        return;
      }
      this.$store.dispatch('Homepage/redeemBIRecord',{'ID':ID})
      .then((json) => {
        this.$refs.table.search({ page: 1, count: 25 });
      });


    },
    deleteRecord(ID){
        if(!confirm("確認刪除此優惠登記記錄？")){
        return ;
      }
      if(!ID){
        return;
      }
      this.$store.dispatch('Homepage/deleteBIRecord',{'ID':ID})
      .then((json) => {
        this.$refs.table.search({ page: 1, count: 25 });
      });

    },
    getSubDegree( parentKey,value ){

      let degree = "";
        $.each(this.selections.degree, (index,item)=>{
        if  ((item.parentKey == parentKey)&&(item.value == value)){
          degree = item.text;
        }   
      });

      return degree;
    },

    getTranslated(key,value){
      let result = "/";
      switch(key){
        case 'accountID':
        case 'store':
        $.each(this.selections.store, (index,item)=>{
        if(item.ID == value){
          if(key == 'accountID'){result = item.accountID;}
          else if(key == 'store'){result =   result = `${item.name} (${item.address})` ;}
        }   
         });
        break;


        case 'updateTime':
        case 'createTime':
          if(value !=null){
          //   let dateTime = value.split(' ');
          // return dateTime[0];
          return value;
        }else{
          return '';
        }
          
        break;
        case 'promoteStatus':
        if(value == "Y"){
          return "已換領";
        }else{
          return "未領取";
        }

        break;
        
        case 'leftAxis':
        case 'rightAxis':
        result = this.getSubDegree("X",value);
        break;
        case 'leftShort':
        case 'rightShort':
          result = this.getSubDegree("S",value);
        break;
        case 'leftLight':
        case 'rightLight':
        result = this.getSubDegree("L",value);
        break;
        case 'informationFlag':
        case 'smsFlag':
        case 'emailFlag':

          if(value == "true"){
            result = '是';
          }else if(value == "false"){
            result = '否';
          }else{
            result = 'N/A';
          }
        break;
        default:
      $.each(this.selections[key], (index,item)=>{
        if(item.value == value){
          result = item.text;
        }   
      });
        break;

      }


      return result;

    },

    setAllSelections(list) {
            // console.log(list);
            $.each(list, (index, item) => {
                if (this.selections[item.type]) {
                    // if (item.parentKey) {
                    //     if (!this.selections[item.type][item.parentKey]) {
                    //         this.selections[item.type][item.parentKey] = [];
                    //     }
                    //     this.selections[item.type][item.parentKey].push(item);
                    // } else { // without parentKey
                    //     this.selections[item.type].push(item);
                    // }
                    this.selections[item.type].push(item);

                }
            });
            // console.log(this.selections);
        },

      getAllSelections(key) {

    this.$store.dispatch('Homepage/getBISelections',key)
      .then((json) => {
            this.setAllSelections( json.data.list);   
      });


            // $.ajax({
            //         url: `${config.apiDomain}/selection/${key}List`,
            //         type: 'GET',
            //         dataType: 'json',
            //         data: {},
            //     })
            //     .done((data) => {
            //         if (data.status != 200) {
            //             alert(`getAll${key} Error: ${data.status}`);
            //             return;
            //         }
            //         // console.log(data);
            //         this.setAllSelections(key, data.data.list);
            //     })
            //     .fail(function() {
            //         alert(`getAll${key} fail`);
            //     })
        },

  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/Registration/RegistrationList.vue